import { Button } from 'src/ui/common/atoms/button';
import { media } from 'src/ui/common/mixins/media';
import styled from 'styled-components';

export const StyledLoadMoreButton = styled(Button)`
    margin-top: 10px;
    font-weight: 500;

    ${media.sm`
    height: 50px;
    margin-top: 20px;
  `}

    ${media.md`
    margin-top: 30px;
  `}

  ${media.lg`
    margin: 40px 0 20px;
  `}
`;

export const StyledCollection = styled.div`
    display: grid;

    a {
        display: grid;
        height: 100%;
    }
`;
